import React, { useState } from 'react';
import coownspaceLogo from '../../Assests/images/logo/co-own-space-black.png';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header id="header-main" className="header header-fixed">
            <div className="header-inner">
                <div className="tf-container xl">
                    <div className="row">
                        <div className="col-12">
                            <div className="header-inner-wrap">
                                <div className="header-logo">
                                    <span className="site-logo">
                                        <a href='/'><img id="logo_header" alt="CoOwnSpace Logo" loading="lazy" src={coownspaceLogo} /></a>
                                    </span>
                                </div>
                                <nav className={`main-menu ${isMenuOpen ? 'active' : ''}`}>
                                    <ul className="navigation">
                                        <li className={location.pathname === "/" ? "active" : ""}>
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className={location.pathname === "/properties" ? "active" : ""}>
                                            <Link to="/properties">Properties</Link>
                                        </li>
                                        <li className={location.pathname === "/channelpartner" ? "active" : ""}>
                                            <Link to="/channelpartner">Channel Partners</Link>
                                        </li>
                                        <li className={location.pathname === "/contact" ? "active" : ""}>
                                            <Link to="/contact">Contact</Link>
                                        </li>
                                    </ul>
                                </nav>
                                <div className="header-right">
                                    <div className="phone-number">
                                        <div className="icons">
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.875 5.625C1.875 12.5283 7.47167 18.125 14.375 18.125H16.25C16.7473 18.125 17.2242 17.9275 17.5758 17.5758C17.9275 17.2242 18.125 16.7473 18.125 16.25V15.1067C18.125 14.6767 17.8325 14.3017 17.415 14.1975L13.7292 13.2758C13.3625 13.1842 12.9775 13.3217 12.7517 13.6233L11.9433 14.7008C11.7083 15.0142 11.3025 15.1525 10.935 15.0175C9.57073 14.5159 8.33179 13.7238 7.30398 12.696C6.27618 11.6682 5.48406 10.4293 4.9825 9.065C4.8475 8.6975 4.98583 8.29167 5.29917 8.05667L6.37667 7.24833C6.67917 7.0225 6.81583 6.63667 6.72417 6.27083L5.8025 2.585C5.75178 2.38225 5.63477 2.20225 5.47004 2.07361C5.30532 1.94498 5.10234 1.87507 4.89333 1.875H3.75C3.25272 1.875 2.77581 2.07254 2.42417 2.42417C2.07254 2.77581 1.875 3.25272 1.875 3.75V5.625Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </div>
                                        <p><a href="tel:+919941111019" className="">
                                            (+91) 99411 11019
                                        </a></p>
                                    </div>
                                    <div
                                        className="mobile-button"
                                        onClick={toggleMenu}
                                    >
                                        <i className={`icon-menu ${isMenuOpen ? 'open' : ''}`}></i>
                                    </div>
                                </div>
                            </div>
                            {isMenuOpen && (
                                <div className={`offcanvas-menu ${isMenuOpen ? 'open' : ''}`}>
                                    {/* Header Section */}
                                    <div className="offcanvas-header">
                                        <div className="offcanvas-logo">
                                            <img src={coownspaceLogo} alt="CoOwnSpace Logo" />
                                        </div>
                                        <button
                                            className="close-btn"
                                            onClick={toggleMenu}
                                        >
                                            ×
                                        </button>
                                    </div>

                                    <ul>
                                        <li className={location.pathname === "/" ? "active" : ""}>
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className={location.pathname === "/properties" ? "active" : ""}>
                                            <Link to="/properties">Properties</Link>
                                        </li>
                                        <li className={location.pathname === "/channelpartner" ? "active" : ""}>
                                            <Link to="/channelpartner">Channel Partners</Link>
                                        </li>
                                        <li className={location.pathname === "/contact" ? "active" : ""}>
                                            <Link to="/contact">Contact</Link>
                                        </li>
                                    </ul>

                                    <div className="support">
                                        <span className="text-need px-4" style={{padding:"20px"}}> Need help?</span>
                                        <ul className="mb-info">
                                            <li>Call Us Now: <a href="tel:+919941111019" className="">
                                                (+91) 99411 11019
                                            </a></li>
                                            <li>Support 24/7:  <a href="mailto:support@coownspace.com" className=''>
                                                support@coownspace.com
                                            </a></li>
                                            <li>
                                                <div className="wrap-social d-flex gap-3">
                                                    <p>Follow us:</p>
                                                    <a href="https://www.facebook.com/coownspace">
                                                        <i className="icon-fb"></i>
                                                    </a>

                                                    <a href='https://www.linkedin.com/company/coownspace/'>
                                                        <i className="icon-linked"></i>
                                                    </a>
                                                    <a href='https://www.instagram.com/coownspace/'>
                                                        <i className="icon-ins"></i>
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
